import {
  CancelApplicationInterviewDocument,
  CancelApplicationInterviewMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCancelApplicationInterview = () => {
  const [cancelApplicationInterview, { loading }] = useMutation(
    CancelApplicationInterviewDocument,
    {
      extractorFn: (data) => data.atsMutations.cancelAtsInterview,
    }
  )

  return {
    loading,
    cancelApplicationInterview(variables: CancelApplicationInterviewMutationVariables) {
      return cancelApplicationInterview({
        variables,
      })
    },
  }
}
